import React from 'react';
import { Checkbox } from '@els/els-react--checkbox';
import { RadioButtonGroup } from '@els/els-react--radio-button';
import './ProcessOptions.scss';

export default class ProcessOptions extends React.PureComponent {
  render() {
    const {
      // process options
      processOptionTitleAndBiblio,
      toggleProcessOptionTitleAndBiblio,

      processOptionAbstract,
      toggleProcessOptionAbstract,

      processOptionFullAbstract,
      setProcessOptionFullAbstract,

      processOptionPartialAbstract,
      setProcessOptionPartialAbstract,

      processOptionHitDetails,
      toggleProcessOptionHitDetails,
    } = this.props;

    return (
      <fieldset className="create-alert-dialog-fieldset">
        <legend className="sr-only">Include in email</legend>
        <div className="create-alert-dialog-row create-alert-dialog-row-process-options">
          <div className="create-alert-dialog-column-label" aria-hidden>
            Include in email:
          </div>
          <div className="create-alert-dialog-column-content">
            {processOptionTitleAndBiblio && (
              <Checkbox
                data-e2e="alert-process-option-title-biblio"
                label={processOptionTitleAndBiblio.label}
                onChange={toggleProcessOptionTitleAndBiblio}
                checked={processOptionTitleAndBiblio.checked}
                disabled={processOptionTitleAndBiblio.disabled}
                className="create-alert-process-option"
              />
            )}
            {processOptionAbstract && (
              <Checkbox
                data-e2e="alert-process-option-abstract"
                label={processOptionAbstract.label}
                onChange={toggleProcessOptionAbstract}
                checked={processOptionAbstract.checked}
                disabled={processOptionAbstract.disabled}
                className="create-alert-process-option"
              />
            )}
            <fieldset className="create-alert-dialog-process-options-radios">
              <legend className="sr-only">Abstract length</legend>
              {processOptionFullAbstract && (
                <RadioButtonGroup.Option
                  className="create-alert-process-option"
                  checked={processOptionFullAbstract.checked}
                  disabled={processOptionFullAbstract.disabled}
                  onChange={setProcessOptionFullAbstract}
                  label={processOptionFullAbstract.label}
                />
              )}
              {processOptionPartialAbstract && (
                <RadioButtonGroup.Option
                  className="create-alert-process-option"
                  checked={processOptionPartialAbstract.checked}
                  disabled={processOptionPartialAbstract.disabled}
                  onChange={setProcessOptionPartialAbstract}
                  label={processOptionPartialAbstract.label}
                />
              )}
            </fieldset>
            {processOptionHitDetails && (
              <Checkbox
                data-e2e="alert-process-option-hit-details"
                label={processOptionHitDetails.label}
                onChange={toggleProcessOptionHitDetails}
                checked={processOptionHitDetails.checked}
                disabled={processOptionHitDetails.disabled}
                className="create-alert-process-option"
              />
            )}
          </div>
        </div>
      </fieldset>
    );
  }
}
